import React, { useRef, useEffect, useState } from "react";

import useHttp from "../../../../hooks/use-http";

import moment from "moment";
import convertToExcel from "../../../../components/ExportToExcel";
import Pagination from "../../../../components/Pagination";
import { useNavigate  } from "react-router-dom";

const PurchaseOrderReport = () => {
  const frmRef = useRef({});
  
  const navigate  = useNavigate ();
  const handleButtonClick = () => {
    navigate("/purchasewise");
  };
  const [employeeId, setEmployeeId] = useState();
  const [employeeData, setEmployeeData] = useState([]);
  const [employeeAllData, setEmployeeAllData] = useState([]);
  const [regionId, setRegionId] = useState();
  const [regionData, setRegionData] = useState([]);

  const [collectionCenterId, setCollectionCenterId] = useState();
  const [collecticnCenterdata, setCollectionCenter] = useState([]);
  const [data, setData] = useState([]);

  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const [farmActivityData, setFarmActivityData] = useState([]);
  const [farmActivityId, setFarmActivityId] = useState();

  const [plotData, setPlotData] = useState([]);

  const [plotId, setPlotId] = useState();

  const {
   
    sendRequest: getWarehouseData,
  } = useHttp();

  const [cropAreaData, setCropAreaData] = useState([]);

  const [cropwiseAreaCovered, setcropwiseAreaCovered] = useState([]);
  const [executivewiseProcurement, setexecutivewiseProcurement] = useState([]);
  const [executivewiseAreaCovered, setexecutivewiseAreaCovered] = useState([]);

  const handleFDateChange = (e) => {
    //console.log("handleFDateChange", e.target.value);
    setSelectedFromDate(e.target.value);
  };
  const handleTDateChange = (e) => {
    setSelectedToDate(e.target.value);
  };

  // var date =date.setDate(date.getDate() + 10);

  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  d.setDate(d.getDate() - 15);

  const fromDate = d.toISOString().slice(0, 10);
  const [selectedFromDate, setSelectedFromDate] = useState(fromDate);

  const toDate = new Date().toISOString().slice(0, 10);

  //console.log("toDate", toDate);

  const [selectedToDate, setSelectedToDate] = useState(toDate);

  const {
   
    sendRequest: getprocurementData,
  } = useHttp();

  const loadCountData = (id) => {
    FillReports(id);
  };

  const FillReports = (employeeId, regionId) => {
    var d = new Date(selectedToDate);

    d.setDate(d.getDate() + 1);

    //console.log("d", d);
    var tdate = moment(d).format("DD/MM/YYYY");

    var fdate = moment(selectedFromDate).format("DD/MM/YYYY");
    //var tdate=moment(selectedToDate).format("DD/MM/YYYY");
    var urlfilter = "";

    urlfilter = urlfilter + `&fromDate=${fdate}`;
    urlfilter = urlfilter + `&toDate=${tdate}`;

    if (employeeId > 0) {
      urlfilter = urlfilter + `&fieldExecutiveId=${employeeId}`;
    }

    //console.log("log employeeId", employeeId);

    var url = `/api/purchaseOrderMIS/?orgId=${localStorage.getItem(
      "orgId"
    )}${urlfilter} `;

    getprocurementData(
      {
        url: url,
      },
      (data) => {
        //console.log("reportdata", data);
        setData(data);
      }
    );
  };

  useEffect(() => {
    FillReports(0, 0);
  }, [getprocurementData]);

  const {
   
    sendRequest: getEmp,
  } = useHttp();
  useEffect(() => {
    getEmp(
      {
        url: `/api/employee/?useCase=Warehouse&orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        var emplist = data.output; //data.output.filter((item) => item.useCase == "Procurement");

        setEmployeeData(emplist);
      }
    );
  }, [getEmp]);

  const fieldsToExport = [
    "purchaseOrderDate",
    "docNo",
    "warehouseName",
    "employeeName",
    "vendorName",
    "vendorCode",
    "billingAddress ",
    "billingCity",
    "billingState",
    "billingCountry",
    "billingZip",
    "shippingAddress ",
    "shippingCity",
    "shippingState",
    "shippingCountry",
    "shippingZip",
    "lineTotalAmount",
    "discountPercentage",
    "discountAmount",
    "totalAmount",
    "taxPercentage",
    "taxAmount",
    "frieghtCharges",
    "totalPurchase",
    "currencyCode",
    "terms",
    "expectedDeliveryDate",
    "remark",
  ];

  const customHeaders = [
    "Date",
    "Doc No",
    "Warehouse",
    "Farm Manager",
    "Vendor Name",
    "Vendor Code",
    "Billing Address",
    "Billing City",
    "Billing State",
    "Billing Country",
    "Billing ZipCode",
    "Shipping Address",
    "Shipping City",
    "Shipping State",
    "Shipping Country",
    "Shipping ZipCode",
    "Sub Total Amount",
    "Discount (%)",
    "Discount Amount",
    "Total Amount",
    "Tax(%)",
    "Tax Amount",
    "Freight Charges",
    "Purchase Order Amount",
    "Currency",
    "Terms and Conditions",
    "Expected Delivery Date",
    "Reamrk/Note",
  ];

  const handleExportExcel = () => {
    const filename = "PurchaseOrder.xlsx";
    //console.log(fieldsToExport, customHeaders);

    convertToExcel(data, fieldsToExport, filename, customHeaders);
  };

  return (
    <>
      <div className="content-wrapper">
      <div className="row mx-2">
          {" "}
          <div className="col-md-8 mt-3">
            {" "}
            <label className="card-title mx-3">Purchase Order Details</label>
          </div>
          <div className="col-md-4 text-right mt-3">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={handleButtonClick}
            >
              <i className="fas fa-times" />
            </button>
          </div>
        </div>
        <br />
        <section className="content">
          <div className="container-fluid">
        
            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor={"executive_officer"}>
                    {"Warehouse Manager"}
                  </label>

                  <select
                    id="emp_id"
                    className="form-control"
                    ref={(el) => (frmRef.current["emp_id"] = el)}
                    value={employeeId}
                    onChange={(e) => {
                      var userid = 0;
                      if (e.target.value != "--Select--")
                        userid = e.target.value;

                      setEmployeeId(userid);
                    }}
                  >
                    <option>--Select--</option>
                    {employeeData &&
                      employeeData.map((x) => (
                        <option
                          key={x.empId}
                          employee-id={x.empId}
                          value={x.empId}
                        >
                          {x.employeeName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  {" "}
                  <label htmlFor={"from_date"}>{"From Date"}</label>
                  <input
                    type={"date"}
                    id={"date"}
                    required
                    // ref={(el) => (frmRef.current["pdate"] = el)}
                    className="form-control"
                    max={currentDate}
                    value={selectedFromDate}
                    onChange={handleFDateChange}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  <label htmlFor={"to_date"}>{"To Date"}</label>

                  <input
                    type={"date"}
                    id={"date"}
                    required
                    // ref={(el) => (frmRef.current["pdate"] = el)}
                    className="form-control"
                    max={currentDate}
                    value={selectedToDate}
                    onChange={handleTDateChange}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  <label>&nbsp;</label>
                  <button
                    className="form-control btn btn-sm btn-primary"
                    onClick={(e) => {
                      FillReports(employeeId, regionId);
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>

              <div className="col-md-3"></div>
            </div>
          </div>
          <h5>Please select the parameters to get the desired result</h5>
          <hr />
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="text-right my-2">
              <button
                type="button"
                className="btn btn-sm btn-warning"
                onClick={handleExportExcel}
              >
                <i className="fas fa-file-excel"></i>
              </button>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "1.4rem" }}>
                    <table className="table table-bordered table-responsive text-center table-sm">
                      <thead>
                        <tr className="table-header">
                          <th> Date </th>
                          <th> Doc No </th>
                          <th>Warehouse</th>
                          <th>Farm Manager</th>
                          <th>Vendor Name</th>
                          <th>Vendor Code</th>
                          <th> Billing Address</th>
                          <th> Billing City</th>
                          <th> Billing State</th>
                          <th> Billing Country</th>
                          <th> Billing ZipCode</th>
                          <th> Shipping Address</th>
                          <th> Shipping City</th>
                          <th> Shipping State</th>
                          <th> Shipping Country</th>
                          <th> Shipping ZipCode</th>
                          <th> Sub Total Amount </th>
                          <th> Discount (%) </th>
                          <th> Discount Amount </th>
                          <th> Total Amount </th>
                          <th> Tax(%) </th>
                          <th> Tax Amount </th>
                          <th> Freight Charges</th>
                          <th> Purchase Order Amount</th>
                          <th> Currency</th>
                          <th> Terms and Conditions</th>
                          <th> Expected Delivery Date</th>
                          <th>Reamrk/Note</th>
                        </tr>
                      </thead>

                      {currentItems &&
                        currentItems.map((itm, i) => {
                          return (
                            <tr key={i} className="tablerowview">
                              <td> {itm.purchaseOrderDate} </td>
                              <td>{itm.docNo}</td>
                              <td>{itm.warehouseName}</td>
                              <td>{itm.employeeName}</td>
                              <td>{itm.vendorName}</td>
                              <td>{itm.vendorCode}</td>

                              <td> {itm.billingAddress} </td>

                              <td> {itm.billingCity} </td>

                              <td> {itm.billingState} </td>

                              <td> {itm.billingCountry} </td>
                              <td> {itm.billingZip} </td>

                              <td> {itm.shippingAddress} </td>

                              <td> {itm.shippingCity} </td>

                              <td> {itm.shippingState} </td>

                              <td> {itm.shippingCountry} </td>
                              <td> {itm.shippingZip} </td>

                              <td> {itm.lineTotalAmount} </td>
                              <td> {itm.discountPercentage} </td>
                              <td> {itm.discountAmount} </td>
                              <td> {itm.totalAmount} </td>

                              <td> {itm.taxPercentage} </td>
                              <td> {itm.taxAmount} </td>
                              <td> {itm.frieghtCharges} </td>
                              <td> {itm.totalPurchase} </td>
                              <td> {itm.currencyCode} </td>

                              <td> {itm.terms} </td>
                              <td> {itm.expectedDeliveryDate} </td>

                              <td> {itm.remark} </td>
                            </tr>
                          );
                        })}
                    </table>
                  </div>

                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default PurchaseOrderReport;
